const formValidation = require('./components/formValidation');

function successMessage($form, message) {
    let toSuccesContainer = $('.js-success-container').offset().top - $('.l-header_wrapper').height();

    $form.addClass(window.styleConstants.hideClass);
    $('.js-success-container').removeClass(window.styleConstants.hideClass);
    $('.js-success-message').html(message);

    window.scrollTo({
        top: toSuccesContainer,
        left: 0,
        behavior: 'smooth'
    });
}

$(document).ready(() => {
    $('.js-confirm-subscription').on('submit', (e) => {
        const button = $('.js-confirm-subscription-button');
        const url = button.data('href');
        const $form = $(e.target);

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        $form.spinner().start();
        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: (data) => {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                } else {
                    successMessage($form, data.msg);
                }
            },
            error: (err) => {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $form.spinner().stop();
            }
        });
    });
});
